import { Tooltip } from 'antd';

const columns = (onPlayerClick) => [
  {
    title: 'Table',
    dataIndex: ['table'],
    key: 'table',
    width: '35px',
  },
  {
    title: 'Player 1',
    dataIndex: ['player1', 'firstName'],
    key: 'firstname',
    width: '150px',
    render: (text, record) => {
      const playerName = `${record.player1.firstName} ${record.player1.lastName}`;
      return (
        <Tooltip title={`Show ${playerName} game history`}>
          <a
            onClick={(e) => {
              e.preventDefault();
              onPlayerClick && onPlayerClick(record.player1);
            }}
            href="#"
          >
            {playerName}
          </a>
        </Tooltip>
      );
    },
  },
  {
    title: 'Army',
    dataIndex: ['player1', 'armyName'],
    key: 'armyName',
    width: '150px',
    render: (text, record) => {
      if (!text) {
        return <i style={{ color: '#999' }}>Missing from BCP</i>;
      }
      return (
        <Tooltip title="Open army list in BCP">
          <a
            target='_BLANK'
            href={`https://bestcoastpairings.com/list/${record.player1.armyListObjectId}`}
            rel='noreferrer'
          >
            {text}
          </a>
        </Tooltip>
      );
    },
  },
  {
    key: 'firstname',
    width: '35px',
    render: (_text, _record) => {
      return <b>VS</b>;
    },
  },
  {
    title: 'Player 2',
    dataIndex: ['player2', 'firstName'],
    key: 'firstname',
    width: '150px',
    render: (text, record) => {
      const playerName = `${record.player2.firstName} ${record.player2.lastName}`;
      return (
        <Tooltip title={`Show ${playerName} game history`}>
          <a
            onClick={(e) => {
              e.preventDefault();
              onPlayerClick && onPlayerClick(record.player2);
            }}
            href="#"
          >
            {playerName}
          </a>
        </Tooltip>
      );
    },
  },
  {
    title: 'Army',
    dataIndex: ['player2', 'armyName'],
    key: 'armyName',
    width: '150px',
    render: (text, record) => {
      if (!text) {
        return <i style={{ color: '#999' }}>Missing from BCP</i>;
      }
      return (
        <Tooltip title="Open army list in BCP">
          <a
            target='_BLANK'
            href={`https://bestcoastpairings.com/list/${record.player2.armyListObjectId}`}
            rel='noreferrer'
          >
            {text}
          </a>
        </Tooltip>
      );
    },
  },
  {
    title: 'Score',
    dataIndex: ['player1Game', 'gamepoints'],
    key: 'gamepoints',
    width: '35px',
    render: (text, record) => {
      return `${record?.player1Game?.gamePoints ?? '?'}-${record?.player2Game?.gamePoints ?? '?'}`;
    },
  },
];

export { columns };
